import getRole from './getRole';
import getSkill from './getSkill';

export default (params) => {
  const { preTag, addSection } = params;

  let data = {
    toExport: false,
  };

  if (
    preTag === 'projects' ||
    preTag === 'research_experience' ||
    preTag === 'education' ||
    preTag === 'extra_curricular' ||
    preTag === 'work_experience' ||
    addSection
  ) {
    data = {
      ...data,
      toExport: true,
    };
  }
  if (preTag === 'skill') {
    return getSkill(preTag, data);
  }
  return {
    object: 'block',
    type: `${preTag}_role_details`,
    data,
    nodes: getRole(params),
  };
};
